<div class="chart">
  <ng-container *ngIf="(!data || data.length <= 0) && loading">
    <div class="noData">
      <mat-spinner strokeWidth="3" diameter="100"></mat-spinner>
    </div>
  </ng-container>
  <ng-container *ngIf="(!data || data.length <= 0) && !loading">
    <div class="noDataText">No drilldown data to display</div>
  </ng-container>
  <ng-container *ngIf="data && data.length > 0">
    <mat-table #table [dataSource]="dataSource">
      <div>
        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>
      </div>

      <ng-container
        *ngFor="let column of displayedColumns; let colIndex = index"
        [matColumnDef]="column"
      >
        <ng-container *ngIf="displayedHeaderColumns[0] == 'referenceLink'">
          <ng-container *ngIf="colIndex == 0">
            <mat-header-cell *matHeaderCellDef class="drilldown">
            </mat-header-cell>
            <mat-cell *matCellDef="let item" class="drilldown">
              <ng-container *ngIf="item[column].value">
                <a href="{{ item[column].value }}" target="_blank"
                  ><fa-icon [icon]="faEdit"></fa-icon
                ></a>
              </ng-container>
            </mat-cell>
          </ng-container>
          <ng-container *ngIf="colIndex != 0">
            <mat-header-cell *matHeaderCellDef>
              {{ displayedHeaderColumns[colIndex] }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let item"
              [ngStyle]="{
                'background-color': item[column].color,
                color: item[column].textColor
              }"
            >
              <div
                class="fixUL"
                [innerHtml]="item[column].value || '&nbsp;'"
              ></div>
            </mat-cell>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="displayedHeaderColumns[0] != 'referenceLink'">
          <mat-header-cell *matHeaderCellDef>
            {{ displayedHeaderColumns[colIndex] }}
          </mat-header-cell>

          <mat-cell
            *matCellDef="let item"
            [ngStyle]="{
              'background-color': item[column].color,
              color: item[column].textColor
            }"
          >
            <div
              class="fixUL"
              [innerHtml]="item[column].value || '&nbsp;'"
            ></div>
          </mat-cell>
        </ng-container>
      </ng-container>
      <mat-row
        matRipple
        id="row-{{ index }}"
        *matRowDef="let row; columns: displayedColumns; let index = index"
      >
      </mat-row>
    </mat-table>
  </ng-container>
  <div class="paginator" [hidden]="true">
    <mat-paginator
      [pageSizeOptions]="[5, 10, 20, 50, 100, 500]"
      showFirstLastButtons
      (page)="resizeData()"
    ></mat-paginator>
  </div>
</div>
